module.exports = __webpack_public_path__ + "img/image-map-3-d02ff04c.png";